import { render, staticRenderFns } from "./SaldoRentabilidade.vue?vue&type=template&id=39913a8b"
import script from "./SaldoRentabilidade.vue?vue&type=script&lang=js"
export * from "./SaldoRentabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports